import Vue from "vue";

export default {
	state: {
		requirementResponse: {},
		requirementResponseList: [],
		scoreByRequirement: {},
		address: {},
		requirementResponseConditionList: []
	},
	mutations: {
		setRequirementResponseOnState(state, rr) {
			state.requirementResponse = rr;
		},
		setRequirementResponseListOnState(state, list) {
			state.requirementResponseList = list;
		},
		setScoreByRequirement(state, score) {
			state.scoreByRequirement = score;
		},
		setAddressByCEP(state, address) {
			state.address = address;
		},
		setRequirementResponseConditionListOnState(state, list) {
			state.requirementResponseConditionList = list;
		}
	},
	actions: {
		async getRequirementResponse({ commit }, { idInvite, idRequirement, dontSetOnState, isIframeContext = false }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("requirement/response/" + idInvite + "/" + idRequirement, {}, { isIframeContext })
					.then((response) => {
						this.state.loading = false;
						if (!dontSetOnState) commit("setRequirementResponseOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						throw error;
					});
			});
		},
		async getRequirementResponseDetails(_, { idInvite, idRequirement }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("requirement/response/details/" + idInvite + "/" + idRequirement)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getRequirementResponseScoreByRequirement({ commit }, idRequirement) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("requirement/response/" + idRequirement)
					.then((response) => {
						this.state.loading = false;
						commit("setScoreByRequirement", response.data.data);
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						throw error;
					});
			});
		},
		getRequirementResponseListByInvite({ commit }, idInvite) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("requirement/response/invite" + idInvite)
					.then((response) => {
						this.state.loading = false;
						commit("setRequirementResponseListOnState", response.data.data);
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		async updateRequirementResponse(_, requirementResponse) {
			this.state.loading = true;
			return new Promise((resolve) => {
				mapToBack(requirementResponse).then((mappedResponse) => {
					let url = "requirement/response/" + mappedResponse.idInvite + "/" + mappedResponse.idRequirement;
					Vue.prototype.$http.put(url, mappedResponse).then((response) => {
						this.state.loading = false;
						resolve(response);
					});
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		async createRequirementResponse(_, requirementResponse) {
			this.state.loading = true;
			return new Promise((resolve) => {
				mapToBack(requirementResponse).then((mappedResponse) => {
					Vue.prototype.$http.post("requirement/response", mappedResponse).then((response) => {
						this.state.loading = false;
						resolve(response);
					});
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		async createOrUpdateRequirementResponse(_, requirementResponse) {
			const { isIframeContext = false } = requirementResponse;
			this.state.loading = true;
			try {
				const mappedResponse = await mapToBack(requirementResponse);
				const response = await Vue.prototype.$http.post("requirement/response/createOrUpdate", mappedResponse, {
					isIframeContext
				});
				this.state.loading = false;
				return response.data.data;
			} catch (error) {
				console.error(error);
				this.state.loading = false;
				throw error;
			}
		},
		async deleteRequirementResponse(_, { idInvite, idRequirement }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.delete("requirement/response/" + idInvite + "/" + idRequirement).then((response) => {
					this.state.loading = false;
					resolve(response);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		async updateRequirementResponseWorkflow(_, input) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("requirement/response/inviteStatus", input)
					.then((response) => {
						this.state.loading = false;
						response.data.isError ? reject(response.data.data) : resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		async updateRequirementsResponseWorkflow(_, input) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("requirement/response/requirementsStatus", input)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		async getAddressByCEP({ commit }, cep) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.getExternal(`https://viacep.com.br/ws/${cep}/json/`).then((response) => {
					this.state.loading = false;
					commit("setAddressByCEP", response.data);
					resolve(response.data);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		async getRequirementResponseConditionList({ commit }, { idInvite, idRequirement, isIframeContext = false }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get(`requirement/response/${idInvite}/${idRequirement}/conditions`, {}, { isIframeContext })
					.then((response) => {
						this.state.loading = false;
						commit("setRequirementResponseConditionListOnState", response.data.data);
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						throw error;
					});
			});
		},
		async updateOnValidityChange(_, objectData) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put(`requirement/response/${objectData.idInvite}/${objectData.idRequirement}/validityChange`)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		// TODO anderson.bauermann remover esse método checkQuestionConditionIsSatisfied após resolvermos as condições com requisitos do tipo tabela
		async checkQuestionConditionIsSatisfied(_, objectData) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`requirement/response/conditionSafisfied`, objectData)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		}
	},
	getters: {
		requirementResponse({ requirementResponse }) {
			return requirementResponse;
		},
		requirementResponseList({ requirementResponseList }) {
			return requirementResponseList;
		},
		scoreByRequirement({ scoreByRequirement }) {
			return scoreByRequirement;
		},
		address({ address }) {
			return address;
		},
		requirementResponseConditionList({ requirementResponseConditionList }) {
			return requirementResponseConditionList;
		}
	}
};

const mapToBack = (requirementResponse) => {
	return new Promise((resolve) => {
		let answer = requirementResponse.answer;
		if (answer != null && typeof answer == "object") {
			answer = requirementResponse.answer.map((response) => {
				return typeof requirementResponse.answer == "object" ? response.value : response;
			});
			// retorna o array como uma string
			answer = JSON.stringify(answer);
		}

		if (answer == "null") {
			console.warn("requirementResponseStore.mapToBack", "answer is 'null'", requirementResponse);
			answer = null;
		}

		let retObject = {
			idInvite: parseInt(requirementResponse.idInvite),
			idRequirement: parseInt(requirementResponse.idRequirement),
			date: new Date(Date.now()),
			issueDate: requirementResponse.issueDate,
			validityDate: requirementResponse.validityDate,
			answer,
			identifier: requirementResponse.identifier,
			justification: requirementResponse.justification,
			observation: requirementResponse.observation,
			userConfirm: requirementResponse.userConfirm,
			status: parseInt(requirementResponse.status),
			login: requirementResponse.login,
			questionAnswers: requirementResponse.questionAnswers,
			deletedFilesId: requirementResponse.deletedFilesId,
			scoreValue: parseFloat(requirementResponse.scoreValue) || 0
		};
		resolve(retObject);
	});
};
